import { RouteObject } from "./types/routes";
import settings from "./config/settings";
import Home from "./features/home/pages/Home";
import ListProjects from "./features/projects/pages/ListProjects";
import CreateProjects from "./features/projects/pages/CreateProjects";
import AddPartners from "./features/partners/pages/CreatePartners";
import EditProjects from "./features/projects/pages/EditProjects";
import DetailsProjects from "./features/projects/pages/DetailsProjects";
import User from "./features/user/pages/User";
import Error404 from "./components/Errors/Error404";


export const routes: RouteObject[] = [
  { action: "open", entity: "Home", to:  '/', element: Home },
  { action: "project", entity: "new-project", to:  '/new/projects/:axeId', element: EditProjects },
  { action: "project", entity: "update-project", to:  '/update/projects/:id', element: EditProjects },
  { action: "listProject", entity: "new-project", to:  '/list/projects', element: ListProjects },
  { action: "detailProject", entity: "detail-project", to:  '/detail/projects/:id', element: DetailsProjects },
  { action: "register", entity: "register", to:  '/register', element: CreateProjects },

  { action: "edit", entity: "Partner", to:  '/create/structure', element: AddPartners},
  

  { action: "edit", entity: "Account", to:  '/account', element: User},

  { action: "", entity: "", to:  '*', element: Error404},
];


export default {};